<template>
  <div class="component--edit-view-list">
    <div class="inner-wrap">
      <!-- <div v-if="data.type=='Time'"> -->
        <List :action="action" :path="path" :defaultFilter="defaultFilter" :defaultData="defaultData"></List>
        <!-- </div> -->
      
    </div>
  </div>
</template>

<script>
import List from "@/views/custom/List";
export default {
  props: ["data","k","field","action","setup"],
  components: {List},
  created() {
  },
  async beforeMount(){
    let key=this.setup.key;
    let id = this.$route.params.id;

    this.path=this.setup.path;
    this.defaultFilter[key]=id;
    this.defaultData[key]=id;
  },
  methods: {
  },
  data() {
    return {
      path:"",
      defaultFilter:{},
      defaultData:{}
    }
  }

}
</script>

<style lang="scss" scoped>
.component--edit-view-list{
  flex-grow: 1;
  overflow-x: auto;
  .inner-wrap{
    table{
      width: 100%;
      tbody {
        input{
          width: 80px;
        }
      }
    }
  }
  .align-right{
    text-align: right;
  }

}
</style>